import React, { FC, useEffect, useState } from "react";

import BreadcrumbText from "../../../../components/components-text/breadcrumb-text";
import InputBox from "../../../../components/input-box/input-box";
import SelectPolicyHolder from "../components/select-policy-holder/select-policy-holder";
import MainButton from "../../../../components/main-button";
import LeftInfoModal from "../../../../components/left-info-modal";
import SelectBox from "../../../../components/select-box/select-box";
import { Label } from "../../../../components/form";
import RequiredDocumentsStep from "../new-insured/required-documents/required-documents-step";
import { TakerDataContainer } from "../../../hirings/new-hiring/health/health-taker/taker-data-style";
import { NewInsuredContainer } from "../new-insured/newInsuredStepper-style";
import { images } from "../../../../assets";

import SupplementsServices from "../../../../services/SupplementsServices";
import ConstantsServices from "../../../../services/ConstantsServices";
import useForm from "../hooks/useForm";
import { SupplementsContext } from "../../../../context/supplements/SupplementsContext";
import { getMediatorCode } from "../../../../utils/mediatorCode";
import { getPolicyNumber, redirect } from "../utils";
import { validateWaitingPeriodData } from "./utils";
import { CompanyDataResponse } from "../../../../services/ConstantsServices.dto";
import { WaiverOfWaitingPeriodsProps } from "../basic-data/basic-data.types";
import { OtherCompany } from "../utils.type";
import { withGeneral } from "../../../../context/mixin/with-general";

const WaiverOfWaitingPeriods: FC<WaiverOfWaitingPeriodsProps> = ({ history, setLoading }) => {
  const supplementsContext = React.useContext(SupplementsContext);
  const [modal, setModal] = useState<{ msg: string; status: boolean; type: string }>({
    msg: "",
    status: false,
    type: "",
  });
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [hasOriginCompany, setHasOriginCompany] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [otherCompaniesList, setOtherCompaniesList] = useState([]);
  const [showCompaniesErrorModal, setShowCompaniesErrorModal] = useState(false);

  const { values, errors, handleChange, handleMultipleChanges, setErrors } = useForm(
    {
      companiaOrigen: "",
      numPoliza: "",
      documents: { uploadDocuments: [] },
      nameSelected: "0",
      isWaiverOfWaitingPeriods: true,
    },
    () => validateWaitingPeriodData(values, supplementsContext.supplementDocs),
    isFirstTime
  );

  useEffect(() => {
    getCompaniesList();
  }, []);

  const getCompaniesList = async () => {
    setLoading(true);
    const responseCompanies = await ConstantsServices.getCompanies({
      loader: false,
      setLoading: () => {},
    });
    if (responseCompanies.length <= 0) {
      setShowCompaniesErrorModal(true);
    }
    const otherCompanies = responseCompanies
      .map(
        (company: CompanyDataResponse): OtherCompany => ({
          value: company.COD_CIA,
          label: company.DESC_CIA,
        })
      )
      .sort((companyA: OtherCompany, companyB: OtherCompany) =>
        companyA.label.localeCompare(companyB.label)
      );
    setOtherCompaniesList(otherCompanies);
    setLoading(false);
  };

  const handleSubmit = async () => {
    const response = await SupplementsServices.sendBasicDataModificationsEmail(values);

    if (response.data.status) {
      setModal({
        msg: "Los datos han sido enviado correctamente",
        status: true,
        type: "success",
      });
    } else {
      setModal({ msg: response.data.msg, status: true, type: "error" });
    }
  };

  const validateForm = () => {
    const { errors, hasValidation } = validateWaitingPeriodData(values, supplementsContext.supplementDocs);
    if (hasValidation) {
      setConfirmationModal(true);
    } else {
      setErrors(errors);
    }
    setIsFirstTime(false);
  };

  return (
    <NewInsuredContainer>
      <div className="subTitle">
        <BreadcrumbText>NUEVO SUPLEMENTO - SOLICITUD EXENCIÓN DE CARENCIAS</BreadcrumbText>
      </div>
      <div className="personal-data-row form-width container-background">
        <div className="personal-data-item col-50">
          <div className="inputBox">
            <InputBox
              placeholder="Mediador"
              required={true}
              disabled={true}
              value={getMediatorCode()}
              onChange={() => {}}
              type={"letters"}
            />
          </div>
        </div>
        <div className="personal-data-item col-50">
          <div className="inputBox">
            <InputBox
              placeholder="Datos de Póliza a modificar"
              required={true}
              disabled={true}
              value={getPolicyNumber()}
              onChange={() => {}}
              type={"letters"}
            />
          </div>
        </div>
      </div>
      <SelectPolicyHolder
        onlyInsureds={true}
        handleChange={handleChange}
        handleMultipleChanges={handleMultipleChanges}
        values={values}
        title={"PERSONA SOBRE LA QUE SE SOLICITA LA EXENCIÓN DE CARENCIAS"}
      />

      <div className="personal-data-row form-width container-background">
        <div className="personal-data-label">
          <Label className="required">¿Tiene una póliza de salud en vigor?</Label>
        </div>

        <div className="radioBox">
          <label htmlFor="poliza-si">
            <input
              type="radio"
              id="poliza-si"
              name="hasPoliza"
              value="si"
              onChange={() => setHasOriginCompany(true)}
            />
            <span>Sí</span>
          </label>
        </div>

        <div className="radioBox">
          <label htmlFor="poliza-no">
            <input
              type="radio"
              id="poliza-no"
              name="hasPoliza"
              value="no"
              onChange={() => setHasOriginCompany(false)}
            />
            <span>No</span>
          </label>
        </div>
      </div>

      <div className="personal-data-row form-width container-background">
        <div className="personal-data-item col-50">
          <div className="selectBox">
            <SelectBox
              required
              disabled={!hasOriginCompany}
              optionsText={otherCompaniesList}
              optionKey={"label"}
              optionValue={"label"}
              initialValue={values.companiaOrigen}
              defaultValue={values.companiaOrigen}
              onChange={(value: string) => handleChange("companiaOrigen", value)}
              errorCode={errors.companiaOrigen}
            />
            <label>Compañía de origen</label>
          </div>
        </div>

        <div className="personal-data-item col-50">
          <div className="inputBox">
            <InputBox
              placeholder="Número de póliza"
              type="text"
              required
              disabled={!hasOriginCompany}
              value={values.numPoliza}
              onChange={(value: string) => handleChange("numPoliza", value)}
              errorCode={errors.numPoliza}
            />
          </div>
        </div>
      </div>

      <div className="personal-data-row form-width container-background no-padding">
        <div className="personal-data-item col-100">
          <RequiredDocumentsStep
            values={values}
            errors={errors}
            handleChange={handleChange}
            hideTitle
            hideInsurance
            title="JUSTIFICATIVOS DE LA SOLICITUD DE EXENCIÓN DE CARENCIAS"
            setErrors={setErrors}
          />
        </div>
      </div>
      <TakerDataContainer>
        <div className="colSin-100 topMargin20 bottomMargin20">
          <div className="personal-data-buttons">
            <div className="personal-data-buttons__item">
              <MainButton
                withTab={true}
                icon={true}
                type={"white"}
                iconImg={images.IconArrowLeftBlue}
                disabled={false}
                text="Atrás"
                onClick={() => history.push(`/suplementos/${getPolicyNumber()}`)}
              />
            </div>
            <div className="personal-data-buttons__item">
              <MainButton withTab={true} text="Enviar" onClick={validateForm} />
            </div>
          </div>
        </div>
      </TakerDataContainer>
      <LeftInfoModal
        img={modal.type === "error" ? images.WarningError : images.IconCheckGreen2}
        mainTitle={modal.type === "error" ? "Error" : "Aviso"}
        mainText={modal.msg}
        noSecondaryButton={true}
        buttonText={modal.type === "error" ? "Cerrar" : "Continuar"}
        active={modal.status}
        onClickAccept={
          modal.type === "error"
            ? () => setModal({ msg: "", status: false, type: "" })
            : () => redirect(setModal, history)
        }
        close={
          modal.type === "error"
            ? () => setModal({ msg: "", status: false, type: "" })
            : () => redirect(setModal, history)
        }
        className={modal.type === "error" ? "error" : "info"}
      />
      <LeftInfoModal
        img={images.IconCheckGreen2}
        mainTitle={"Aviso"}
        mainText={"Se va a enviar un suplemento de exención de carencia"}
        secondaryText={"¿Desea Continuar?"}
        noSecondaryButton={false}
        buttonText={"Si"}
        closeButtonText={"NO"}
        active={confirmationModal}
        onClickAccept={handleSubmit}
        close={() => setConfirmationModal(false)}
        className={"info"}
      />
      <LeftInfoModal
        img={images.WarningError}
        className="error"
        mainTitle="Aviso"
        mainText="No se ha podido recuperar el listado de Otras Compañías, por favor inténtelo más tarde"
        buttonText="Cerrar"
        close={() => setShowCompaniesErrorModal(false)}
        active={showCompaniesErrorModal}
        onClickAccept={() => setShowCompaniesErrorModal(false)}
        noSecondaryButton
      />
    </NewInsuredContainer>
  );
};

export default withGeneral(WaiverOfWaitingPeriods);
